/*
  ANOM drops — countdown + purchase lock. RUW Marketing, 2026-09-28.

  Any element with data-anom-drop="<ISO time>" gets data-state="upcoming" | "live" | "soldout"
  (soldout = released and the server rendered it with data-soldout) and its
  [data-cd="d|h|m|s"] children filled in once a second.
  If any element also carries data-anom-lock and is still upcoming, <html> gets
  .anom-drop-locked: CSS hides the buy buttons and product-form submits are refused.
  At the release second the lock lifts in place — no reload needed.
*/
(function () {
  if (window.__anomDrop) return;
  window.__anomDrop = true;

  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  function set(el, unit, value) {
    el.querySelectorAll('[data-cd="' + unit + '"]').forEach(function (n) {
      if (n.textContent !== String(value)) n.textContent = value;
    });
  }

  function tick() {
    var now = Date.now();
    var locked = false;
    document.querySelectorAll('[data-anom-drop]').forEach(function (el) {
      var at = Date.parse(el.getAttribute('data-anom-drop'));
      if (isNaN(at)) return;
      var diff = at - now;
      var state = diff > 0 ? 'upcoming' : (el.hasAttribute('data-soldout') ? 'soldout' : 'live');
      if (el.getAttribute('data-state') !== state) el.setAttribute('data-state', state);
      if (state === 'upcoming') {
        var s = Math.floor(diff / 1000);
        set(el, 'd', Math.floor(s / 86400));
        set(el, 'h', pad(Math.floor((s % 86400) / 3600)));
        set(el, 'm', pad(Math.floor((s % 3600) / 60)));
        set(el, 's', pad(s % 60));
        if (el.hasAttribute('data-anom-lock')) locked = true;
      }
    });
    document.documentElement.classList.toggle('anom-drop-locked', locked);
  }

  // Refuse any add-to-cart submit while a drop on the page is still locked.
  document.addEventListener('submit', function (e) {
    if (!document.documentElement.classList.contains('anom-drop-locked')) return;
    var form = e.target;
    if (form && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Units left for the selected size on drop product pages.
  function updateUnits(variantId) {
    document.querySelectorAll('[data-anom-units]').forEach(function (box) {
      var data;
      try { data = JSON.parse(box.querySelector('script[type="application/json"]').textContent); } catch (err) { return; }
      var v = data.variants[String(variantId)];
      var out = box.querySelector('[data-anom-size-left]');
      if (!out || !v) return;
      if (v.qty <= 0) {
        out.textContent = 'Size ' + v.size + ' is sold out';
        out.setAttribute('data-level', 'out');
      } else {
        out.textContent = 'Only ' + v.qty + ' left in size ' + v.size;
        out.setAttribute('data-level', v.qty <= 1 ? 'last' : 'low');
      }
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id' && e.target.value) updateUnits(e.target.value);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
      if (evt && evt.data && evt.data.variant) updateUnits(evt.data.variant.id);
    });
  }

  // Drop alerts (snippets/anom-drop-notify.liquid). With a Klaviyo list id: subscribe email + SMS
  // through Klaviyo's client API (company id read off the Klaviyo onsite script). Otherwise let the
  // Shopify customer form submit normally, with the phone carried as a tag.
  function normPhone(raw) {
    var d = (raw || '').replace(/[^0-9+]/g, '');
    if (!d) return '';
    if (d.charAt(0) === '+') return d;
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    return d;
  }

  function klaviyoCompany() {
    var s = document.querySelector('script[src*="klaviyo.com/onsite/js/"], script[src*="company_id="]');
    if (s) {
      var m = s.src.match(/company_id=([A-Za-z0-9]+)/) || s.src.match(/onsite\/js\/([A-Za-z0-9]+)\//);
      if (m) return m[1];
    }
    return null;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-anom-notify')) return;
    var phoneEl = form.querySelector('[data-anom-phone]');
    var phone = normPhone(phoneEl && phoneEl.value);
    var email = (form.querySelector('input[type="email"]') || {}).value;
    var list = form.getAttribute('data-klaviyo-list');
    var company = list ? klaviyoCompany() : null;

    if (!list || !company) {
      var tags = form.querySelector('[data-anom-tags]');
      if (phone && tags && tags.value.indexOf('sms-optin') === -1) tags.value += ',sms-optin,sms ' + phone;
      return; // native Shopify submit
    }

    e.preventDefault();
    var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    var attrs = { email: email, subscriptions: subs };
    if (phone) { attrs.phone_number = phone; subs.sms = { marketing: { consent: 'SUBSCRIBED' } }; }
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'ANOM drop alert', profile: { data: { type: 'profile', attributes: attrs } }
      }, relationships: { list: { data: { type: 'list', id: list } } } } })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      form.querySelector('.anom-notify__fields').hidden = true;
      form.querySelector('[data-anom-err]').hidden = true;
      form.querySelector('[data-anom-ok]').hidden = false;
    }).catch(function () {
      form.querySelector('[data-anom-err]').hidden = false;
      if (btn) btn.disabled = false;
    });
  });

  function init() {
    tick();
    var idInput = document.querySelector('product-form input[name="id"]');
    if (idInput && idInput.value) updateUnits(idInput.value);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  setInterval(tick, 1000);
})();
